@for (ratingValue of starValues; track $index) {
  <input
    type="radio"
    name="rating"
    [id]="ratingValue + 'stars'"
    [value]="ratingValue"
    [checked]="ratingValue === value"
    (change)="onRatingSelect(ratingValue)"
  />
  <label [for]="ratingValue + 'stars'">
    <fa-icon
      [icon]="ratingValue <= (value || 0) ? filledStar : emptyStar"
      size="2x"
      [attr.aria-label]="ratingValue + ' star(s)'"
    />
  </label>
}
